module.exports = __webpack_public_path__ + "static/group-3-ff62dd3a45dfe668ae4c49e33c1188e9.png";